export const HOME = "/"
export const LOGIN = "/Login"
export const USER ="/user/dashboard"
export const CREATE ="/user/dashboard/records/create"
export const UPDATE ="/user/dashboard/records/update/:id"
export const INCOME ="/user/dashboard/records/income"
export const EXPENSE ="/user/dashboard/records/expense"

